<div class="lovers__pela__causa__container">
  <div class="header__pela__causa">
    <div class="fundo"></div>
    <div class="logos__button__apoie">
      <div class="logos">
        <img
          class="logo__lovers"
          src="assets/images/logos/LogoPelacausa.png"
          alt="Logo Lovers"
        />
        <div class="instituto__container">
          <img
            class="logo__instituto"
            src="assets/images/logos/LogoInstituto.png"
            alt="Logo Instituto"
          />
          <p class="texto__instituto">
            Em parceria com o ICS, agora além de resgatar momentos especiais,
            você também pode contribuir e fazer parte de ações sociais e
            ambientais através dos seus Cacaus.
          </p>
        </div>
      </div>
      <button (click)="irParaMomentosEspeciais()" class="button__apoie">
        Apoie essa causa!
      </button>
    </div>
  </div>
  <div class="cards__momentos__especiais" *ngIf="quantidadeCards > 0">
    <app-card-pela-causa [carregando]="carregandoCards" [experiencias]="experiencias" [quantidadeCards]="quantidadeCards"></app-card-pela-causa>
  </div>
</div>


